import React from 'react'

const FootDash = () => {
  return (
    <footer className="fixed-bottom bg-white shadow py-3">
    <div className="container my-auto">
      <div className="copyright text-center my-auto">
        <span className='small' > © Copyright {new Date().getFullYear()} WhiteHatSeo | All Rights Reserved.  </span>
      </div>
    </div>
  </footer>
  )
}

export default FootDash